import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import es from "./locales/es.json";
import en from "./locales/en.json";

// Custom navigator detector that ONLY returns es/en (clamped). Without
// this clamp, a browser set to "en-GB" or "es-MX" still works fine via
// i18next's fallback chain, but explicit clamping makes the behavior
// deterministic for analytics and avoids edge cases with country codes.
const customDetector = {
  name: "velcorNavigator",
  lookup() {
    if (typeof navigator === "undefined") return undefined;
    const langs = (navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || ""]);
    for (const l of langs) {
      const lc = (l || "").toLowerCase();
      if (lc.startsWith("en")) return "en";
      if (lc.startsWith("es")) return "es";
    }
    return undefined;
  },
};

const lngDetector = new LanguageDetector();
lngDetector.addDetector(customDetector);

i18n
  .use(lngDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
    },
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    detection: {
      // Order matters: localStorage FIRST so a user who manually chose a
      // language keeps their choice; otherwise fall back to the browser
      // language. The `htmlTag` is kept as a last-resort signal for
      // server-rendered pages.
      order: ["localStorage", "velcorNavigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "velcor_lang",
    },
    interpolation: { escapeValue: false },
    returnObjects: true,
    // ── react-i18next binding (Feb 2026 fix) ──────────────────────────────
    // Without explicit `bindI18n`, some components mounted at boot do NOT
    // re-render when `i18n.changeLanguage()` is called later — they keep
    // showing the original-language strings until a manual remount. The
    // default in react-i18next v11+ is "languageChanged" but on this stack
    // we observed it wasn't firing reliably. Explicitly binding ensures
    // every component using `useTranslation()` re-renders on language
    // change AND when resources finish loading.
    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
    },
  });

export default i18n;
